var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2760_17441)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2760_17441",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2760_17441)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0H22.5V24H10.5V0Z",
    fill: "#4C67E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 0H32.5V24H22.5V0Z",
    fill: "#C51918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0H12.5V24H0.5V0Z",
    fill: "#C51918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51387 6.88392C5.50053 6.88392 5.63354 5.89658 5.63354 5.89658L6.114 4.85898V5.27695V5.89658C6.114 6.03004 6.2961 5.76312 6.2961 5.44181C6.2961 5.1205 6.51387 4.63936 6.51387 4.63936C6.51387 4.63936 6.52261 4.47848 6.52864 4.31962C6.56349 4.40135 6.63337 4.47212 6.73944 4.57956C6.75794 4.5983 6.77753 4.61815 6.79824 4.63936C6.92343 4.76766 6.90654 5.10751 6.89193 5.40156C6.8787 5.66785 6.86733 5.89658 6.96506 5.89658C7.17069 5.89658 7.15541 4.97781 7.15541 4.97781L7.50054 5.89658C7.50054 5.89658 7.52722 6.88392 6.51387 6.88392ZM6.51387 4.06424C6.53966 3.91349 6.5364 4.11487 6.52864 4.31962C6.49953 4.25138 6.49484 4.17549 6.51387 4.06424ZM8.03846 8.6835C8.03846 9.48619 7.36689 10.1369 6.53846 10.1369C5.71003 10.1369 5.03846 9.48619 5.03846 8.6835C5.03846 7.88081 5.71003 7.23009 6.53846 7.23009C7.36689 7.23009 8.03846 7.88081 8.03846 8.6835ZM4.26923 11.404H2.5V19.9753H4.26923V11.404ZM10.5 11.404H8.73077V19.9753H10.5V11.404ZM4.73077 11.4785L6.45549 12.5464L8.39938 11.4785H4.73077ZM6.45549 19.9997L4.73077 18.9319H8.39938L6.45549 19.9997ZM4.73077 12.8946H8.34615V13.5654H4.73077V12.8946ZM8.34615 17.8884H4.73077V18.5592H8.34615V17.8884ZM6.57692 17.5157C7.59653 17.5157 8.42308 16.7148 8.42308 15.7269C8.42308 14.739 7.59653 13.9381 6.57692 13.9381C5.55732 13.9381 4.73077 14.739 4.73077 15.7269C4.73077 16.7148 5.55732 17.5157 6.57692 17.5157ZM4.5032 9.2159C4.5032 9.2159 4.56536 11.0832 6.40587 11.0832C8.24638 11.0832 8.54343 9.2159 8.54343 9.2159C8.54343 9.2159 7.83103 10.3598 6.52332 10.3598C5.2156 10.3598 4.5032 9.2159 4.5032 9.2159Z",
    fill: "#F8D000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85865 13.973L6.94114 13.6055C7.35361 14.0567 7.54046 14.31 7.45218 14.7234C7.35363 15.185 6.83554 15.699 6.23361 16.1225C5.86904 16.3791 5.6457 17.0714 5.82662 17.2916L5.6541 17.6055C5.25089 17.1148 5.57316 16.1891 6.12957 15.7975C6.6405 15.438 6.99731 15.0611 7.05955 14.7643C7.10007 14.5711 7.17562 14.3198 6.85865 13.973Z",
    fill: "#C51918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 17C7.27614 17 7.5 16.7761 7.5 16.5C7.5 16.2239 7.27614 16 7 16C6.72386 16 6.5 16.2239 6.5 16.5C6.5 16.7761 6.72386 17 7 17Z",
    fill: "#C51918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87598 15.6504C6.15212 15.6504 6.37598 15.4265 6.37598 15.1504C6.37598 14.8742 6.15212 14.6504 5.87598 14.6504C5.59983 14.6504 5.37598 14.8742 5.37598 15.1504C5.37598 15.4265 5.59983 15.6504 5.87598 15.6504Z",
    fill: "#C51918"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2760_17441"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/MN.900d77a5a27b735ae6b9409b68c7ccb6.svg";
export { ForwardRef as ReactComponent };